
<!--
 * @Author: xing.huang
 * @Date: 2021-02-02 16:20:10
 * @LastEditTime: 2023-03-22 16:05:57
 * @LastEditors: xing.huang
 * @Description: 
 * @FilePath: \iMaster-Web\src\views\customPrint\index.vue
 * @
-->
<template>
    <div style="width:100%;heigh:100%;" class="custom-print">
        <el-card class="table-card">
            <div class="table_common_operbar">
                <el-row>
                    <el-button icon="el-icon-plus" type="primary" size="small" @click="addWindowShow()">新增模板</el-button>
                </el-row>
            </div>
            <el-table :data="tableData" stripe style="width: 100%" class="CustomReportTable">
                <el-table-column type="index" label="序号" width="80" ></el-table-column>
                <el-table-column prop="flowCardTemplateName" label="流转卡名称" min-width="100" ></el-table-column>
                <el-table-column prop="lastModifyUserName" :formatter="parseWorkshopDtos" label="适用范围" min-width="160" show-overflow-tooltip></el-table-column>
                <el-table-column prop="materialType" label="物料类型" min-width="140" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{scope.row.materialType==1?'零件':(scope.row.materialType===0?'产品':' ')}}
                    </template>
                </el-table-column>
                <el-table-column prop="description" label="描述" min-width="140" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createUserName"  label="创建人" min-width="80" show-overflow-tooltip></el-table-column>
                <el-table-column prop="gmtCreate"  label="创建时间" min-width="80"  show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" fixed="right" width="240">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.templateType>3"  @click="showEditDialog(scope.row)" type="text" size="small" >编辑</el-button>
                        <el-button class='btn-del' v-if="scope.row.templateType>3"  @click="deleteCustomReport(scope.row)" type="text" size="small" >删除</el-button>
                        <el-button v-if="scope.row.templateType>3"  type="text" size="small" @click="preview(scope.row)">模板样式</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <el-dialog title="新增流转卡模板" @close="cancelAddDialog" :visible.sync="addDialogVisible" :width="span==5?'30%':'63%'"  center :close-on-click-modal="false">
            <el-form :model="addForm" :rules="rules" ref="addForm" style="width:100%;" class="add_form">
                <div v-if="setup==0" class="setup0">
                    <el-row :gutter="20" style="margin-bottom:0px">
                        <el-col :span="16" :offset="4">
                            <span class="title">模板名称：</span>
                            <el-form-item class="value" prop="flowCardTemplateName" :style="W?{maxWidth:'200px'}:{maxWidth:'140px'}">
                                <el-input size="small" v-model="addForm.flowCardTemplateName" maxlength="100" placeholder="模板名称"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" style="margin-bottom:0px">
                        <el-col :span="16" :offset="4">
                            <span class="title">适用范围：</span> 
                            <el-form-item  class="value" prop='workshopIds'  :style="W?{maxWidth:'200px'}:{maxWidth:'140px'}">
                                <el-select size="small" ref="focusinput" multiple collapse-tags v-model="addForm.workshopIds" placeholder="适用范围" filterable style="display:block;max-width:180px">
                                    <el-option v-for="item  in workershopList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" style="margin-bottom:0px">
                        <el-col :span="16" :offset="4">
                            <span class="title">物料类型：</span>
                            <el-form-item prop="materialType" class="value"  :style="W?{maxWidth:'200px'}:{maxWidth:'140px'}">
                                <el-select size="small"  v-model="addForm.materialType" placeholder="选择物料类型" filterable style="display:block;max-width:180px">
                                    <el-option key="0" label="产品" :value="0"></el-option>
                                    <el-option key="1" label="零件" :value="1"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" style="margin-bottom:0px">
                        <el-col :span="16" :offset="4">
                            <span class="title" style="display: inline-block;width: 70px;">描述：</span>
                            <el-form-item class="value" prop="description" :style="W?{maxWidth:'200px'}:{maxWidth:'140px'}">
                                <el-input size="small" type="textarea" v-model="addForm.description" maxlength="100" placeholder="描述"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                <div v-show="setup==1" class="setup1">
                    <span class="title">标签尺寸：</span>
                    <el-row :gutter="20" style="margin-bottom:0px;margin-top: 10px">
                        <el-col :span="12" >
                            <span class="title">长度：</span>
                            <el-form-item class="value" prop="width" :rules="rules.width" :style="W?{maxWidth:'160px'}:{maxWidth:'140px'}">
                                <el-input size="small" v-model="addForm.width" maxlength="100" placeholder="长度"></el-input>
                            </el-form-item>
                            <span>mm</span>
                        </el-col>
                        
                        <el-col :span="12" >
                            <span class="title">宽度：</span>
                            <el-form-item class="value" prop="height" :rules="rules.height" :style="W?{maxWidth:'160px'}:{maxWidth:'140px'}">
                                <el-input size="small" v-model="addForm.height" maxlength="100" placeholder="宽度"></el-input>
                            </el-form-item>
                            <span>mm</span>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" style="margin-bottom:0px">
                        <el-col :span="24" >
                            <span class="title">纸张方向：</span>
                            <el-form-item class="value" prop="flowCardTemplateName" :style="W?{maxWidth:'180px',display:'block',marginTop: '10px'}:{maxWidth:'140px',display:'block',marginTop: '10px'}">
                                <el-radio v-model="addForm.orientation" :label="0">横向</el-radio>
                                <el-radio v-model="addForm.orientation" :label="1">纵向</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" v-if="setup==1" @click="setup=0">返回上一步</el-button>
                <el-button type="primary" @click="submitAddDialog">确 定</el-button>
                <el-button @click="cancelAddDialog">取 消</el-button>
            </span>
        </el-dialog>

        <el-dialog title="编辑流转卡模板" @close="cancelEditDialog" :visible.sync="editDialogVisible" :width="span==5?'30%':'63%'"  center :close-on-click-modal="false">
            <el-form :model="addForm" :rules="rules" ref="editForm" style="width:100%;" class="add_form">
                <div  class="setup0">
                    <el-row :gutter="20" style="margin-bottom:0px">
                        <el-col :span="16" :offset="4">
                            <span class="title">模板名称：</span>
                            <el-form-item class="value" prop="flowCardTemplateName" :style="W?{maxWidth:'200px'}:{maxWidth:'140px'}">
                                <el-input v-if="setup==0" size="small" v-model="addForm.flowCardTemplateName" maxlength="100" placeholder="模板名称"></el-input>
                                <span v-if="setup==1">{{addForm.flowCardTemplateName}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" style="margin-bottom:0px">
                        <el-col :span="16" :offset="4">
                            <span class="title">适用范围：</span>
                            <el-form-item  class="value"  prop="workshopIds" :style="W?{maxWidth:'200px'}:{maxWidth:'140px'}">
                                <el-select :disabled="setup==1?true:false" size="small" ref="focusinput" multiple collapse-tags v-model="addForm.workshopIds" placeholder="适用范围" filterable style="display:block;max-width:180px">
                                    <el-option v-for="item  in workershopList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                                
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" style="margin-bottom:0px">
                        <el-col :span="16" :offset="4">
                            <span class="title">物料类型：</span>
                            <el-form-item prop="materialType" class="value"  :style="W?{maxWidth:'200px'}:{maxWidth:'140px'}">
                                <el-select size="small"  v-model="addForm.materialType" placeholder="选择物料类型" filterable style="display:block;max-width:180px">
                                    <el-option key="0" label="产品" :value="0"></el-option>
                                    <el-option key="1" label="零件" :value="1"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" style="margin-bottom:0px">
                        <el-col :span="16" :offset="4">
                            <span class="title" style="display: inline-block;width: 70px;">描述：</span>
                            <el-form-item class="value" prop="description" :style="W?{maxWidth:'200px'}:{maxWidth:'140px'}">
                                <el-input v-if="setup==0" size="small" type="textarea" v-model="addForm.description" maxlength="100" placeholder="描述"></el-input>
                                <span v-if="setup==1">{{addForm.description}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                
            </el-form>

            <span slot="footer" class="dialog-footer">
                
                <el-button type="primary" v-if="setup==0" @click="submitEditDialog">确 定</el-button>
                <el-button type="primary" v-if="setup==1" @click="submitEditDialog">调整自定义字段</el-button>
                <el-button @click="cancelEditDialog">取 消</el-button>
            </span>
        </el-dialog>
        <PreviewDialog :isShow="isShow" :maxH="Number(maxH)" :maxW="Number(maxW)" :columnList="columnList" ></PreviewDialog>
    </div>
</template>

<script>
import CommonUtils from '../../util/CommonUtils'
import PreviewDialog from './PreviewDialog.vue'
export default {
    name: 'CustomPrint',
    components: {
        PreviewDialog
    },
	data () {
        let that = this
        return {
            isShow:false,
            maxH:0,
            maxW:0,
            columnList:[],
            loading:false,
            fristLoad:false,
            W:false,
            viewData:{
                inow:0,
            },
            setup:0,
            addForm:{
                flowCardTemplateName:"",
                description: '',        
                workshopIds:[ ],
                width:150,
                height:100,
                materialType:null,
                orientation:0, //0横向/1纵向,
            },
            rules:{
                flowCardTemplateName: [
                    {required: true, message: '模板名称不能为空', trigger: 'blur'},
                ],
                workshopIds:[
                    {required: true, message: '请选择适用范围', trigger: ['blur','change']},
                ],
                materialType:[
                    {required: true, message: '请选择物料类型', trigger: ['blur','change']},
                ],
                width: [
                    {required: true, message: '长度不能为空', trigger: ['blur']},
                    {
                        validator(rule, value, callback) {
                            
                            if (Number.isInteger(Number(value)) && Number(value) > 0) {
                                callback()
                            } else {
                                callback(new Error('长度必须为正整数'))
                            }
                        }, trigger: 'blur'
                    }
                ],
                height: [
                    {required: true, message: '宽度不能为空', trigger: ['blur']},
                    {
                        validator(rule, value, callback) {
                            if (Number.isInteger(Number(value)) && Number(value) > 0) {
                                callback()
                            } else {
                                callback(new Error('宽度必须为正整数'))
                            }
                        }, trigger: 'blur'
                    }
                ],
            },

            pageSize:10,
            tableData:[{},{}],
            tableCurrentPage:1,
            tableTotalPage:100,
            addDialogVisible:false,
            editDialogVisible:false,
            viewDialogVisible:false,
			token: localStorage.getItem("token"),
            workershopList:[],
            permission:JSON.parse(localStorage.getItem("permission"))
        }
    },
    mounted:async function(){
        
        this.initTable();
        this.loadWorkershopLis()
        
        let w  = document.documentElement.clientWidth || document.body.clientWidth;
         w>=1900?this.W = true:this.W = false
        window.onresize=()=>{
            let w  = document.documentElement.clientWidth || document.body.clientWidth;
            w>=1900?this.W = true:this.W = false
        }
        
    },
    deactivated:function(){
        console.log("deactivated");
    },
    computed:{
        span(){
           return this.W?5:7
        }
    },
    methods:{
        loadWorkershopLis(){
            this.$RequestUtil.get({
                url: '/api/factoryModel/getWorkShopList',
                params: {},
                success: (res) => {
                    if (res.code == 0) {
                        this.workershopList = res.data
                    } else {
                        this.$message.error(res.msg || res.message)
                    }
                }
            })
        },
       
        sizeChange(ev){
            this.pageSize = ev
            this.tableCurrentPage = 1
            this.search(1);
        },

        search:function(){
            this.$RequestUtil.get({
                url: '/api/flowCardTemplate/list',
                type:'sync',
				params: {},
                success: (res) => {
                    if(res.msg == this.$Global.RESPONSE.SUCCESS){
                        this.tableData = res.data;
                    }else{
                        this.$message.error(res.msg||res.message);

                    }
                }
            });
        },


        pageChange:function(targetPage){
            
            this.search();
        },

        initTable:function(){
            this.search();
        },

        addWindowShow:function(){
            this.addDialogVisible = true
            if(this.$refs['addForm']){
                this.$refs['addForm'].clearValidate()
            }
        },

        submitAddDialog(){
            this.$refs['addForm'].validate((valid) => {
                if (valid) {
                    if(this.setup==0){
                        this.setup=1
                        return
                    }
                    let info = CommonUtils.cloneObj(this.addForm)
                    this.$store.commit("add_printInfo", info);
                    this.cancelAddDialog()
                    this.$router.push({path: "/Production/CustomAddPrint"})
                }
            })
        },

        cancelAddDialog(){
            this.addForm = {
                flowCardTemplateName:"",
                description: '',        
                workshopIds:[ ],
                width:150,
                height:100,
                orientation:0, //0横向/1纵向,
                flowCardTemplatePropertyDtos:[]
            }
            this.setup = 0
            this.addDialogVisible = false
        },

        updateCustomReport:function(){
           

        },
        
        showEditDialog:async function(rowData){
            this.addForm = {
                flowCardTemplateName:rowData.flowCardTemplateName,
                flowCardTemplateId:rowData.flowCardTemplateId,
                description: rowData.description,        
                workshopIds:(rowData.workshopDtos||[]).map(item=>item.workshopId),
                width:rowData.width,
                height:rowData.height,
                orientation:rowData.orientation, //0横向/1纵向,
                flowCardTemplatePropertyDtos:rowData.flowCardTemplatePropertyDtos,
                materialType:rowData.materialType
            }
            this.editDialogVisible = true
            // this.$router.push({path: '/Production/CustomEditPrint',query:{id:rowData.id}})
            if(this.$refs['addForm']){
                this.$refs['addForm'].clearValidate()
            }
        },

        cancelEditDialog(){
            this.addForm = {
                flowCardTemplateName:"",
                description: '',        
                workshopIds:[ ],
                width:150,
                height:100,
                orientation:0, //0横向/1纵向,
            }
            this.setup = 0
            this.editDialogVisible = false
        
        },

        submitEditDialog(){
            
            this.$refs['editForm'].validate(async (valid) => {
                if (valid) {
                    if(this.setup==0){
                        let params = {
                            flowCardTemplateName:this.addForm.flowCardTemplateName,
                            flowCardTemplateId:this.addForm.flowCardTemplateId,
                            description: this.addForm.description,        
                            workshopIds:this.addForm.workshopIds,
                            materialType:this.addForm.materialType
                        }
                        let res = await this.submitAsync(params)
                        this.initTable()
                        if(res==0){
                            this.setup=1
                        }
                        return
                    }
                    log(this.addForm,1000)
                    let info = CommonUtils.cloneObj(this.addForm)
                    this.$store.commit("add_printInfo", info);
                    this.cancelEditDialog()
                    this.$router.push({path: '/Production/CustomEditPrint'})
                }
            })
        },

        async submitAsync(params){
            let {data,code,msg,message} = await this.$RequestUtil.postAsync({url: '/api/flowCardTemplate/update',params: {...params}})
            if(code==0){
                this.$message.success('编辑成功')
                return code
            }else{
                this.$message.error(msg||message)
            }
        },

        viewCustomReport: async function(rowData){
            
        },

        deleteCustomReport:function(rowData) {
            let message = '此操作将删除自定义打印模板，是否继续';
            this.$confirm(message, '提示', {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$RequestUtil.post({
                    url: '/api/flowCardTemplate/update',
                    type:'sync',
                    params: {
                        flowCardTemplateId:rowData.flowCardTemplateId,
                        is_deleted:true
                    },
                    success: (res) => {
                        if(res.code != -1){
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.initTable()
                        }else {
                          this.$message({
                            type: 'error',
                            message: res.msg||res.message
                          });
                        }
                    }
                });
            });
        },

        parseWorkshopDtos(rowData){
            let str = ''
            if(rowData.workshopDtos&&rowData.workshopDtos.length>0){
                str = rowData.workshopDtos.map(item=>item.workshopName).join('/')
            }
            return str
        },

        preview(rowData){
            this.maxH = CommonUtils.mm2px(rowData.height) 
            this.maxW = CommonUtils.mm2px(rowData.width)
            this.columnList = rowData.flowCardTemplatePropertyDtos
            this.isShow = true
        },
        
    },
    watch: {
        $route: function(to, from) {
            // log(to,from,'触发')
            if(from.path=='/Production/CustomAddPrint'||from.path=='/Production/CustomEditPrint'){
                this.initTable()
            }
        }
    }
}
</script>

<style>
  
  
  
</style>
<style scoped>


.el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
}



.page{
    display: flex;
    justify-content: flex-end;
}

.total_page{
    margin-top: 20px;
    margin-right: 26px;
    color:#606266;
    font-size: 14px;
}

@media screen and (max-width: 1380px){
    .page{
        display: flex;
        justify-content: flex-end;
        margin-bottom:30px;
    }
}
.key{
    font-size: 16px;
    color:#c0c4cc;
    font-family: NotoSansHans-Regula;
    padding-right:10px;
    line-height:3
}
.addForm .value{
    display: inline-block;
    max-width: 180px;
}
.addForm .title{
    width: 70px;
    text-align: right;
    display:inline-block
}
.setup0 .value,.setup1 .value{
    display: inline-block;
}
.value{
    font-size:16px;
    color:#999;
    font-family: NotoSansHans-Regula;

    line-height: 3;
}

</style>





// WEBPACK FOOTER //
// src/views/customPrint/index.vue